<template>
  <div>
    <v-timeline
      align-top
      :reverse="!$vuetify.breakpoint.xs && !$vuetify.breakpoint.sm"
      :dense="$vuetify.breakpoint.xs || $vuetify.breakpoint.sm"
    >
      <app-timeline-item
        v-for="(item, index) in itens"
        :key="index"
        :value="item"
      />
    </v-timeline>
  </div>
</template>

<script>
import AppTimelineItem from '@/components/core/AppTimelineItem';

export default {
  name: 'AppTimeline',

  components: {
    AppTimelineItem,
  },

  props: {
    itens: {
      type: Array,
      required: true,
      default: () => ([]),
    },
  },
};
</script>
